import * as config from '../config'

export default class Level {

    constructor(scene) {
       this.scene = scene;
    }

    static nextLevel() {
        config.other.projects.level += 1;
        config.other.progressBar.toWin *= 1.1;
        config.projectile.code.createdRate *= 0.95;
        config.projectile.bug.createdRate *= 0.95;
        config.projectile.coin.createdRate *= 0.95;
        config.projectile.bug.hp *= 1.1;
        config.manager.hp *= 1.1;
        config.manager.createdRate *= 0.95;
        config.projectile.deadline.speed *= 1.1;
        config.manager.time *= 1.1;
        config.projectile.coin.time *= 1.1;
        config.projectile.bug.value *= 1.05;
        config.projectile.code.value *= 1.05;
        config.projectile.coin.value *= 1.05;
        config.manager.value *= 1.05;
    }

}
